<template>
    <div class="mobile_screen">
        <div class="big_cat_screen">
            <HeaderNav v-if="!isWeixinBrowser()" :navtitle="courseTitle" :beforecolor="'#000'" :backcolor="'#fff'" @returnBack="goToBack"/>
            <div class="imgLazyLoadHead">
                <img v-bind:src="getheadImage()"/>
                <div class="worksheet_intro" v-if="objWorksheetHomeInfo.isBuy === 0"><div class="entry_all" @click="courseIntroClick"><span>资料包介绍 ></span></div></div>
                <div v-else>
                    <div class="entry course_intro"><div class="entry_back" @click="courseIntroClick"><span>资料包介绍 ></span></div></div>
                    <div class="entry faq"><div class="entry_back" @click="contactClick"><span>一键下载 ></span></div></div>
                </div>
            </div>
            <div class="page-navbar">
                <mt-navbar v-if="false" class="page-part" v-model="selected">
                    <mt-tab-item id="1" :style="parseInt(selected) === 1 ? isSelected(courseId) : {cursor: 'pointer'}">课程列表</mt-tab-item>
                </mt-navbar>
                <div class="sty_tab_container">
                    <mt-tab-container v-model="selected" :style="{backgroundColor:getProgramCourseBGColor(courseId2)}">
                        <mt-tab-container-item id="1">
                            <div class="course_list_content" v-bind:style="{backgroundColor:getProgramCourseBGColor(courseId2)}">
                                <div class="course_top"></div>
                                <!--试听-->
                                <template v-if="objWorksheetHomeInfo.isBuy === 0">
                                    <WorksheetItem :style="{'padding-top':'0px'}" :lessonArray="objWorksheetHomeInfo.freeTrial"
                                                 :isFreeTrial="'1'" @lessonItemClick="lessonItemClick"/>

                                    <div class="course_list_title">- 课程列表 -</div>
                                </template>

                                <WorksheetItem :style="{'padding-top':'0px'}" :lessonArray="objWorksheetHomeInfo.lessonArray"
                                             @lessonItemClick="lessonItemClick"/>

                                <div class="lesson_list_bottom"></div>
                            </div>
                        </mt-tab-container-item>
                    </mt-tab-container>
                </div>
            </div>
            <div class="bottom_tool" v-if="objWorksheetHomeInfo.isBuy === 0" :style="{height: adapterBigScreenHeight()}">
                <div class="tabbar_buy" @click="buyProgram">
                    <span>购买课程</span>
                    <div class="go">立即前往</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {MessageBox} from "mint-ui";

    export default {
        data() {
            return {
                selected: '1',
                courseTitle: "",
                courseId: parseInt(this.$route.query.courseId),
                courseId2: 0,
                objWorksheetHomeInfo: {},
                tabId: 0
            }
        },
        methods: {
            adapterBigScreenHeight: function () {
                return this.judgeBigScreen() ? "86px" : "50px";
            },
            judgeBigScreen: function () {
                if (this.isWeixinBrowser() || this.isAppAndroid()) {
                    return false;
                }

                const rate = window.screen.height / window.screen.width;
                let limit =  window.screen.height === window.screen.availHeight ? 1.8 : 1.65; // 临界判断值
                return rate > limit;
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            buyProgram: function () {
                let that = this;
                let vPlatform = that.judgePlatform();
                let vYouZanUrl = this.objWorksheetHomeInfo.buyUrl.replace(new RegExp('https:','g'), '');

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:buyWorksheetBefore:" + that.courseId + ":" + vYouZanUrl;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.buyWorksheetBefore(that.courseId, that.objWorksheetHomeInfo.buyUrl);
                }
            },
            buyCourseSuccess: function () {
                let that = this;
                let url = "/worksheets/getHomeInfo/" + that.courseId;
                that.$axios.get(url).then((response) => {
                    that.objWorksheetHomeInfo = response.data;
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            courseIntroClick: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:viewCourseIntro:" + that.objWorksheetHomeInfo.articleId;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.viewCourseIntro(that.objWorksheetHomeInfo.articleId);
                }
            },
            faqClick: function () {
                let that = this;
                let vPlatform = that.judgePlatform();
                let courseType = 8;

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:viewCourseFaq:" + courseType + ":" + that.courseId;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.viewCourseFaq(courseType, that.courseId);
                }
            },
            contactClick: function () {
                this.$router.push({name: "BFHeadMaster", query: {courseId: this.courseId, courseType: 8}});
            },
            goToBack() {
                let that = this;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (!this.isEmpty(token) && !this.isEmpty(userid) && token.length > userid.length) {
                    if (this.isAppIos()) {
                        document.location = "readingclubapp:gobackMyCourse";
                    }

                    if (this.isAppAndroid()) {
                        window.note.gobackMyCourse();
                    }
                } else {
                    this.goBack(this.$router);
                }
            },
            getStatusHeight() {
                let statusHeight = this.getCount(this.$store.state.statusheight);

                if (statusHeight === 0) {
                    statusHeight = 20;
                }

                return statusHeight;
            },
            showStatus: function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:showStatusView:" + status;
                }

                if (vPlatform === 4) {
                    window.note.showStatusView(status);
                }
            },
            showStatusWhiteDelay(status) {
                let that = this;

                setTimeout(() => {
                    that.showStatusWhite(status);
                }, 200);
            },
            showStatusWhite:function (status) {
                let that = this;

                if (that.isAppIos()) {
                    document.location = "readingclubapp:changeStatusStyle:" + status;
                }

                if (that.isAppAndroid()) {
                    window.note.changeStatusStyle(status);
                }
            },
            getheadImage:function(){
                switch (this.courseId) {
                    case 1:
                        return require('@/Images/course_worksheet_head1.png');
                    case 2:
                        return require('@/Images/course_worksheet_head2.png');
                    case 3:
                        return require('@/Images/course_worksheet_head3.png');
                    default:
                        return "";
                }
            },
            lessonItemClick:function(isFreeTrial, pk) {
                if (isFreeTrial === 0 && this.objWorksheetHomeInfo.isBuy === 0) {
                    this.buyTipClick();
                    return;
                }

                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-IOS app平台
                    document.location = "readingclubapp:viewSingleWorksheet:" + pk;
                } else if (vPlatform === 4) {
                    // 4-android app平台
                    window.note.viewSingleWorksheet(pk);
                }
            },
            buyTipClick:function(){
                MessageBox.confirm('', {
                    message: ' ',
                    title: '要先购买才能上课哦～快去购买吧！',
                    showConfirmButton:false,
                    showCancelButton:true,
                    closeOnClickModal: false,
                    cancelButtonClass:'cancelButton',
                    confirmButtonClass:'confirmButton',
                    cancelButtonText:'知道了'
                });
            },
            isSelected(id) {
                return {
                    color: this.getProgramCourseColor(id),
                    'border-bottom': '3px solid ' + this.getProgramCourseColor(id),
                    cursor: 'pointer'
                };
            },
            scrollToPositin(section) {
                document.getElementById('section_' + section).scrollIntoView();
            },
            geneTitle() {
                switch (this.courseId) {
                    case 1:
                        return "快乐识数1到100";
                    case 2:
                        return "100以内加减法";
                    case 3:
                        return "三年级十大重难点";
                }

                return "";
            }
        },
        created() {
            let that = this;

            // 客户端调用方法组
            window.buyCourseSuccess = that.buyCourseSuccess;
        },
        beforeCreate() {
            let that = this;
            let vCourseId = parseInt(that.$route.query.courseId);
            let url = "/worksheets/getHomeInfo/" + vCourseId;
            that.$axios.get(url).then((response) => {
                that.courseTitle = that.geneTitle();

                that.objWorksheetHomeInfo = response.data;
                that.courseId = vCourseId;
                that.courseId2 = vCourseId;
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        mounted() {
            window.WAfterScrollTop = 0;
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.showStatus(1);
                vm.showStatusWhiteDelay(0);
            });
        },
        beforeRouteLeave(to, from, next) {
            this.showStatus(0);
            window.WAfterScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            next()
        },
        activated() {
            window.scrollTo(0, window.WAfterScrollTop);
        }
    }
</script>
<style scoped>

    img { pointer-events: none; }

    .mobile_screen {
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
    }
    .imgLazyLoadHead {
        position: relative;
        padding: 0;
    }
    .imgLazyLoadHead img {
        display: block;
        width: 100%;
        margin: auto;
    }
    .imgLazyLoadHead .worksheet_intro {
        width: calc(100vmin - 70px);
        position: absolute;
        left: 35px;
        bottom: 15px;
        display: flex;
        justify-content: center;
    }
    .imgLazyLoadHead .entry {
        width: 50vmin;
        position: absolute;
        bottom: 15px;
        display: flex;
        justify-content: center;
    }
    .imgLazyLoadHead span {
        color: white;
        font-size: 13px;
    }
    .imgLazyLoadHead .entry_all {
        width: 100%;
        height: 26px;
        line-height: 26px;
        text-align: center;
        background-color: #00000048;
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
    }
    .imgLazyLoadHead .entry_back {
        width: 120px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        background-color: #00000048;
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
    }
    .imgLazyLoadHead .entry_back img {
        width: 15px;
        height: 15px;
    }
    .entry_back span, .entry_all span {
        color: #ffffff;
    }
    .imgLazyLoadHead .faq {
        left: 50vmin;
    }

    .worksheet_intro {

    }
    .course_list_title {
        font-size: 15px;
        color: #6B6B6B;
        text-align: center;
        padding-top: 30px;
    }

    .course_top {
        height: 10px;
    }

    .lesson_list_bottom {
        height: 50px;
    }
    .sty_tab_container {
        position: relative;
    }
    .bottom_tool {
        position: fixed;
        background-color: #f4f4f4;
        width: 100%;
        z-index: 10000;
        bottom: 0;
        height: 50px;
    }
    .tabbar_buy {
        display: flex;
        height: 50px;
        background-color: #ff505a;
        width: 100%;
        z-index: 10000;
        align-items: center;
        justify-content: center;
    }
    .tabbar_buy span {
        color: white;
        font-size: 17px;
        text-align: center;

    }
    .tabbar_buy .go {
        position: absolute;
        height: 26px;
        line-height: 26px;
        right: 15px;
        background-color: white;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 13px;
        color: #ff505a;
        text-align: center;
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
    }

</style>
